



























import { Component, Prop, Vue } from 'vue-property-decorator'
import FileDetail from '@/components/file/FileDetail.vue'
import UploadModal from '@/components/UploadModal.vue'
import FileRenameModal from '@/components/FileRenameModal.vue'

@Component({
  name: 'file-group-preivew',
  components: { FileDetail }
})
export default class FilePreview extends Vue {
  @Prop()
  fileGroup: FileGroup

  @Prop()
  type: string;

  renameFile () {
    this.$buefy.modal.open({
      parent: this,
      component: FileRenameModal,
      props: {
        fileName: this.fileGroup.name
      },
      hasModalCard: true,
      trapFocus: true,
      canCancel: ['x', 'escape']
    })
  }

  updateFile () {
    this.$buefy.modal.open({
      parent: this,
      component: UploadModal,
      props: {
        fileName: this.fileGroup.name,
        type: this.type
      },
      hasModalCard: true,
      trapFocus: true,
      canCancel: ['x', 'escape']
    })
  }
}
